import { ApiResultVoPageVoSnsPostXResponseVo } from '@schemas/non-auth'
import { fetchAPI } from '@utils/http/apiRequest'
import { useQuery } from '@tanstack/react-query'

interface SnsXListReqModel {
	pageNo: number
	pageSize: number
}

const path = '/restapi/v1/get/sns/x/list'
const queryKeyString = (props: SnsXListReqModel) => ['@sns/x/list', props] as const

export const querySnsXList = async (
	props: SnsXListReqModel,
	cookieHeader?: string,
): Promise<ApiResultVoPageVoSnsPostXResponseVo> => {
	const { pageNo, pageSize } = props
	const params = new URLSearchParams({
		pageNo: String(pageNo),
		pageSize: String(pageSize),
	})
	return fetchAPI({ path, params, cookieHeader })
}

export const usePrefetchSnsXList = (props: SnsXListReqModel, cookieHeader?: string) => {
	return useQuery({
		queryKey: queryKeyString(props),
		queryFn: () => querySnsXList(props, cookieHeader),
		refetchInterval: 1000 * 60,
	})
}
